import React, { useState } from 'react';
import { FaDesktop, FaMobileAlt } from 'react-icons/fa';
import { IoMdArrowDroprightCircle } from 'react-icons/io';
import { MdPhotoLibrary } from 'react-icons/md';
// import productImage from '../../../assets/Docs/product_images.png'

const PhotoLibrary = () => {
    const [activeTab1, setActiveTab1] = useState('web');

    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];

    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => !tab.disabled && setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? 'bg-[#1a9588] text-white shadow-md'
                        : 'bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600'
                        } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={tab.disabled}
                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );

    return (
        <div>
            <div className="text-start">
                <div className="flex items-center gap-4 mb-8">
                    <MdPhotoLibrary className="text-pink-600 text-5xl" />
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Photo Library</h1>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
                <div className="flex flex-wrap gap-2">
                    <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Seller
                    </span>
                    <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Buyer
                    </span>
                </div>
                <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Web
                    </span>
                   
                    <span className="bg-green-100 text-green-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Android
                    </span>
                </div>
            </div>

            <p className="text-start mb-6 text-gray-600 Warehouses">
                Photos add color to your product catalogue & make it more engaging. You can assign upto 10 photos per product.
            </p>



            <div className="mx-auto bg-gray-100 p-6 rounded shadow">


                {/* Process Title */}
                {/* <p className="text-gray-700 mb-2 text-start font-semibold">
                    The process to import Excel data includes the following steps
                </p> */}

                {/* Steps List */}
                <ul className="border border-gray-200 rounded bg-white mb-4 text-start">
                    {[
                        "File Format - JPG",
                        "Maximum Filesize - 2 MB per photo",
                        "Photo Aspect Ratio - 1:1",
                        "Dimensions (W x H) - 800 x 800 pixels (Ideal)",
                        "Color - RGB",
                        "Resolution - 72 DPI",
                    ].map((step, index) => (
                        <li key={index} className="p-3 text-gray-700 hover:bg-gray-50 text-start flex gap-3">

                            <IoMdArrowDroprightCircle className='mt-1' />  {step}
                        </li>
                    ))}
                </ul>

            </div>

            <div className='my-5'>
                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={""}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
                <div className="mx-4  text-gray-600 p-3 font-semibold rounded text-start ">
                    You can upload 10 photos in one go.
                </div>
            </div>

            {/* {renderTabs(activeTab2, setActiveTab2)}
            <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                <img
                    src={content2[activeTab2]}
                    alt={`${activeTab2} view`}
                    className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                />
            </div> */}

            <div className="mt-4 bg-yellow-100 text-orange-500 p-3 rounded text-start">
                Ensure that your photos are in a square format (1:1). If the photo is not in 1:1 ratio, then the Selzor Photo Processor crops the photo from the right.
            </div>

        </div>
    );
};

export default PhotoLibrary;